import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import BPRSList from "../pages/Phase-04/BPRS/BPRSList";

import {
    fetchBprsAssessments,
    deleteBprsAssessment
} from "../store/slices/bprsAssessmentsSlice";

const BPRS = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { bprsAssessments, isLoading } = useSelector((state) => state.bprsAssessments);

    useEffect(() => {
        dispatch(fetchBprsAssessments());
    }, [dispatch]);

    const handleAdd = () => navigate("/phase04/bprs/add");

    const handleEdit = (id) => {
        const assessment = bprsAssessments.find((a) => a.id === id);
        navigate(`/phase04/bprs/edit/${id}`, { state: { assessment } });
    };

    const handleDelete = (id) => {
        dispatch(deleteBprsAssessment(id));
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <BPRSList
                            assessments={bprsAssessments}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default BPRS;
